import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FilterService from "../services/filter";

type FilterInitializerProps = { onChange: () => void };

export default function FilterInitializer({onChange}: FilterInitializerProps) {
    return (
        <span
            className={"" + (FilterService.hasFilter() ? 'active  pointer' : 'inactive')}
            onClick={() => {
                FilterService.reinit();
                if (onChange) {
                    onChange()
                }
            }}
            >
            <FontAwesomeIcon icon={'trash-alt'} size="2xs" />
        </span>
    );
}